<template>
  <div id="welcome">
    <div style="background: #fff; overflow: hidden">
      <SearchQuery :creatBy='creatBy' ref="search" class="search-content">
        <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 15px" @click="search">{{
          $t("message.button.search") }}
        </el-button>
        <el-checkbox style="margin-left: 15px;bottom: -8px;" v-model="checked">{{ $t("message.button.BOMshow")
        }}</el-checkbox>
      </SearchQuery>
      <div style="height: 6px;"></div>
    </div>
    <div class="search_cotent">
      <div v-loading="loading">
        <!-- <vxe-grid
          v-bind="gridOptions"
          resizable
          ref="table"
          >
        </vxe-grid> -->

        <!-- <vxe-table
						border
            height="480"
            class="mytable-scrollbar"
						:data="tableData"
						:checkbox-config="{labelField: 'a1', visibleMethod: showCheckbox}">
						<vxe-column v-for="item in columnList" :type="item.type" :key="item.index" :field="item.field" :title="item.title"></vxe-column>
					</vxe-table> -->

        <!-- <vxe-toolbar>
            <template #buttons>
              <vxe-button @click="getSelectEvent">导出模板</vxe-button>
            </template>
</vxe-toolbar> -->


        <!-- <vxe-toolbar>
            <template #tools>
              <el-button type="primary" size="small"  @click="getSelectEvent">导出模板</el-button>
            </template>
          </vxe-toolbar> -->

        <vxe-table border ref="xTable" show-overflow resizable :row-config="{ isHover: true }" :tree-config='{}'
          height="440" class="mytable-scrollbar" :data="tableData">
          <vxe-column type="checkbox" width="60">
            <template #header="{ checked, indeterminate }">
              <span class="custom-checkbox" @click.stop="checkAllRows(checked)">
                <i v-if="indeterminate" class="fa fa-minus-square-o"></i>
                <i v-else-if="checked" class="fa fa-check-square-o"></i>
                <i v-else class="fa fa-square-o"></i>
              </span>
            </template>
            <template #checkbox="{ row, checked, indeterminate }">
              <span class="custom-checkbox" @click.stop="checkRow(row, checked, indeterminate)" v-if="!!row.a1">
                <i v-if="indeterminate" class="fa fa-minus-square-o"></i>
                <i v-if="checked" class="fa fa-check-square-o"></i>
                <i v-else class="fa fa-square-o"></i>
              </span>
            </template>
          </vxe-column>

          <!-- <vxe-column type="checkbox" title="" width="40" tree-node></vxe-column> -->
          <vxe-column v-for="item in columnList" :key="item.index" :field="item.field" :title="item.title"
            :minWidth="item.miniWidth" :tree-node='item.treeNode'>
          </vxe-column>
        </vxe-table>

        <!-- <el-pagination
            small
            class="pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalRols"
          >
          </el-pagination> -->
      </div>

    </div>
  </div>
</template>
<script>
import 'font-awesome/css/font-awesome.min.css'
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";
import TitleTag from "@/components/titleTag";
import SearchQuery from "@/views/workBench/search/searchItem/search.vue";
import axios from "axios";
// import XEUtils from "xe-utils";
import XLSX from "xlsx";
import XLSXS from 'xlsx-js-style'
import FileSaver from "file-saver";
export default {
  name: "Show",
  data() {
    return {
      checked: false,
      loading: false,
      reportPage: true,

      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      creatBy: 'BOM',

      totalRols: "",
      search_data: "",
      get_data: [],
      selectGroup: [],
      select_value: "",
      checkedList: [],
      uncheckedList: [],


      tableToolbar: {
        print: true,
        // export:true,
        zoom: true,

        // custom: true,
        buttons: [{ code: 'myInsert', name: '', type: 'text', },],
        slots: {
          tools: "tools",
        },
      },
      tableData: [],
      columnList: [],
      gridOptions: {
        columns: [],
        data: [],
        border: true,
        resizable: true,
        showOverflow: true,
        // stripe: true,
        height: 420,
        align: "left",
        highlightHoverRow: true,
        treeConfig: { children: "children", expandAll: true },

      },
    };
  },
  components: {
    SearchQuery,
    TitleTag,
  },
  mounted() { },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },

    formatCheck(row) {
      // console.log('11111',row);
      // return true;
      console.log(row);
      // return !!row['1'];
    },

    getSelectEvent() {
      const rows = this.checkedList.length ? this.res.filter(i => this.checkedList.includes(i.objId)) : [];
      let getData = (item) => {
        let n = {};
        this.columnList.map((i, e) => {
          Object.assign(n, { [i.field]: item.cells[e].val })
        })
        return n;
      }
      let data = [];
      let getAll = (arr) => {
        arr.map(i => {
          let n = getData(i);
          data.push(n);
          if (i.children?.length) {
            getAll(i.children)
          }
        });
      }
      getAll(rows)
      // this.exportBOM(data);
      this.exportTitle = "BOM模板导出" + this.formatDate(new Date());
      this.Excel();

    },
    checkRow(row, checked) {
      this.$refs.xTable.toggleCheckboxRow(row);
      if (checked) {
        this.checkedList.splice(this.checkedList.indexOf(row.objId), 1)
      } else {
        this.checkedList.push(row.objId)
      }
    },
    checkAllRows(checked) {
      this.$refs.xTable.toggleAllCheckboxRow()
      let arr = [... new Set(this.res.map(i => i.objId))];
      this.checkedList = checked ? [] : arr;
    },
    getColumns() {
      axios.get("/pmdm/import/getTemplateTitle").then(res => {
        console.log(res);

        // let columnList = [];
        const colInfo = res.data.object
        console.log(colInfo);
        this.columnList = colInfo.names.map((i, e) => ({ title: i, field: 'a' + (e + 1), minWidth: "140", sortable: true }));
        this.columnList[2].treeNode = true;
        console.log(this.columnList);
        this.list = colInfo.names.map((i, e) => ({ name: i, requiredType: colInfo.required[e] }))
      })
    },
    Excel() {

      // 将数据源转成我们需要的二维数组
      // const body = [...this.list]
      const header = this.list.map(i => {
        const color = i.requireType ? '#f00' : '#000'
        const obj =
        {
          v: i.name,
          alignment: {
            vertical: 'center', // 垂直居中
            horizontal: 'center'
          },
          t: 's',
          s: {
            font: {
              name: "微软雅黑",
              sz: 16,
              bold: true,
              color
            },
          }
        }
        return obj
      })
      let body = [header];

      // body.unshift(...h);// 将定义好的表头添加到 body 中
      const sheet = XLSXS.utils.aoa_to_sheet(body);// aoa_to_sheet 将二维数组转成 sheet
      // // 设置列宽
      const cols = new Array(this.list.length).fill({ wch: 20 })
      sheet['!cols'] = cols; // 将cols添加到sheet中

      const getCharCol = (n) => {
        let s = '',
          m = 0
        while (n > 0 || n == 0) {
          m = n % 26 + 1
          s = String.fromCharCode(m + 64) + s
          n = (n - m) / 26
        }
        return s
      }
      console.log(sheet);

      this.list.map((i, e) => {
        const m = getCharCol(e) + '1';
        const color = i['requiredType'] ? 'F56C6C' : '000'
        sheet[m].s = {
          font: {
            name: "宋体",
            sz: 11,
            // bold: true,
            color: { rgb: color }
          },
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          },
        }
      })
      const workbook = XLSXS.utils.book_new();// 创建虚拟的 workbook
      XLSXS.utils.book_append_sheet(workbook, sheet, 'sheet1'); // 向 workbook 中添加 sheet
      XLSXS.writeFile(workbook, this.exportTitle + '.xlsx'); // 导出 workbook
    },

    exportBOM(arr) {
      NProgress.start();
      // 对数据预处理
      let title = this.columnList.map(i => i.title);
      let data = [];
      arr.map(i => data.push(Object.values(i)));
      data.unshift(title);
      console.log(data);

      // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([this.toBuffer(wbout)], {
        type: "application/octet-stream",
      });
      // 保存导出
      FileSaver.saveAs(blob, "BOM模板导出" + this.formatDate(new Date()) + '.xlsx');
      NProgress.done();
    },
    search() {
      this.checkedList = [];
      this.tableData = [];
      this.res = [];
      const obj = this.$refs.search.getSearchInfo();
      this.$refs.search.searchShow = false;
      if (this.checked) {
        obj.currentPage = 0;
      }
      this.loading = true;
      axios
        .post("/search/advanced/searchBomAndExportExcel", obj)
        .then((res) => {
          this.getTable(res);
          this.res = res.data.object.tableBOM.rows;
        });
    },
    getTable(res) {
      if (JSON.stringify(res.data.object) != '{}') {
        const data = res.data.object.tableBOM;

        let tempList = this.getAllRows(data.rows);

        tempList.map((i, e) => {
          if (e && i.objId == tempList[e - 1].objId) {
            i['a1'] = ''; i['a2'] = '';
          }
          this.tableData.push(i)
        })
        this.totalRols = data.totalRecords;

        // tempList = this.arrTrans(tempList);  //将tempList中相同的objId项分组 ==>二维数组
        // tempList = tempList.reduce((a, b) => a.concat(b)); //将二维数组拍平

        this.tableToolbar.buttons[0].name = this.$t("message.title.totalResults") + this.totalRols + this.$t("message.title.resultsNums")
      } else {
        this.tableToolbar.buttons[0].name = this.$t("message.title.totalResults") + 0 + this.$t("message.title.resultsNums")
      }
      this.loading = false;
    },
    arrTrans(data) {
      let list = [];
      let arr = data.map(i => i.objId);
      [...new Set(arr)].map(i => {
        let n = data.filter(j => j.objId == i);
        list.push(n)
      })
      return list
    },
    getBOMSeq(array, l, n,) {

      if (!array || !array.length) return;
      let level = l || 1;
      let parentLevel = n || 0;
      array.forEach((item, e) => {

        if (item.children && item.children.length) {
          this.getBOMSeq(item.children, level + 1);
        }
      })
      return array;
    },

    getAllRows(arr, l) {
      // console.log(arr);
      let newArr = [];
      let level = l || 1;
      // let L = isLeaf || false;
      arr.map((i, e) => {
        let n = this.getRow(i, level);
        console.log(n);
        if (n['a3'].indexOf('-') != -1) {
          n['a1'] = '', n['a2'] = '';
        }
        newArr.push(n);
        if (i.children != null) {
          n.children = this.getAllRows(i.children, level + 1);
        } else {
          n.children = [];
        }
      });
      return newArr;
    },

    getRow(arr, level) {
      let n = { 'level': level };
      // console.log(this.gridOptions.columns);
      // console.log(arr);
      n.objId = arr.objId;
      this.columnList.map((i, e) => {
        let val = arr.cells[e].val || '';
        Object.assign(n, { [i.field]: val });
      });
      // console.log(n);
      return n;
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear();
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours());
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes());
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + hh + mm + ss;
    },

  },
  created() {
    this.getColumns();
  }
};
</script>


<style scoped>
.custom-checkbox {
  font-size: 18px;
}

.pagination {
  margin-top: 15px;
  text-align: left;
}

.search-condition {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  margin-left: 10px;
}

.search-title {
  /* width: 120px; */
  padding-right: 120px;
  margin-left: 15px;
}

.search-content {
  margin: 10px 10px;
}

.btn {
  display: inline-block;
  padding: 3px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn6 {
  height: 32px;
  /* line-height: 32px; */
  color: #f5a521;
  border-color: rgba(245, 165, 33, 0.5);
  background: rgba(245, 165, 33, 0.2);
  margin: 0;
  position: relative;
  /* top: 2px; */
}

.btn6:hover {
  color: #fff;
  background: rgba(245, 165, 33, 0.4);
}

.el-selector-search {
  width: 18px;
}

.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #FFFFFF;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #F1F1F1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #A8A8A8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #FFFFFF;
}
</style>